export default __webpack_public_path__ + "static/media/header_bg.b9b67db3.svg";